import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Css/DevelopmentAppraisal.css";
import "./Css/DevelopmentAppraisal-responsive.css";

import { Ripple } from "primereact/ripple";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  InputNumber,
  InputNumberValueChangeEvent,
} from "primereact/inputnumber";

import ErrorPage from "../../../../../Components/ErrorPage";
import NoDataCreated from "../../../../../Components/NoDataCreated";
import PageLoader from "../../../../../Components/PageLoader";
import { goToTop } from "../../../../../Components/goToTop";
import { InputText } from "primereact/inputtext";
import { getAppCurrencyType } from "../../../../../Utils/Common";

import {
  DevelopmentAppraisalDataList,
  mapDevelopmentAppraisalDataLists,
} from "../../../../../Controllers/Types/Project/DefaultModels/DevelopmentAppraisal/DevelopmentAppraisalDataList";

import { FinanceCost } from "../../../../../Controllers/Types/Project/DefaultModels/DevelopmentAppraisal/FinanceCost";
import { LandCost } from "../../../../../Controllers/Types/Project/DefaultModels/DevelopmentAppraisal/LandCost";
import { OtherCost } from "../../../../../Controllers/Types/Project/DefaultModels/DevelopmentAppraisal/OtherCost";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../Controllers/hooks";
import { getAllDevelopmentAppraisalList } from "../../../../../Controllers/Thunks/DevelopmentAppraisalThunks";
import {
  addDevelopmentAppraisal,
  addFinanceCost,
  addLandCost,
  addOtherCost,
  deleteDevelopmentAppraisal,
  deleteOtherCostData,
} from "../../../../../Api/Project/DefaultServices/DevelopmentAppraisalService/DevelopmentAppraisalApiService";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../Controllers/Store";
import { hasPermission } from "../../../../../Controllers/Selectors/permissionsSelector";
import TableActionLoader from "../../../../../Components/TableActionLoader";

const DevelopmentAppraisal: React.FC = () => {
  const location = useLocation();
  const toast = useRef<Toast>(null);
  const navigate = useNavigate();
  const currencySymbol = getAppCurrencyType();
  const projectData = location.state.data;
  // const isShared: boolean = projectData.sharedBy !== null ? true : false;
   const isShared: boolean = projectData.can_edit;

  const dataLoading = useAppSelector((state) => state?.developmetAppraisalList?.loader);
  const errorMessage = useAppSelector((state) => state?.developmetAppraisalList?.errorDisplay);

  const [initialDataloading, setInitialDataLoading] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [updateLoading, setUpdateLoading] = useState<boolean>(false);
  const [viewState, setViewState] = useState<"basic" | "detail">("basic");
  const [dataState, setDataState] = useState<"Add" | "Edit">("Edit");

  const [developmentAppraisalData, setDevelopmentAppraisalData] = useState<DevelopmentAppraisalDataList[]>([]);

  //   folder informations

  const [folderId, setFolderId] = useState<number>(0);
  const [sharedBy, setSharedBy] = useState<any | null>(null);
  const [folderData, setFolderData] = useState<any | null>(null);

  /* ****************************** For basic cost ******************************* */
  const [basicCostTotalAmount, setBasicCostTotalAmount] = useState<number>(0);
  const [showBasicCostDetail, setShowBasicCostDetail] = useState<boolean>(false);
  const [showBasicCostModal, setShowBasicCostModal] = useState<boolean>(false);

  const [basicCostUpdateHasChanges, setBasicCostUpdateHasChanges] = useState<boolean>(false);
  const [basicCostDeleteLoadingId, setBasicCostDeleteLoadingId] = useState<number | null>(null);

  //   need to alter model with values.
  // and need to set value initally.
  const [costValues, setCostValues] = useState<DevelopmentAppraisalDataList[]>([]);
  /* ****************************************************************************** */

  /* ****************************** For finance cost ****************************** */
  const [showFinanceCostModal, setShowFinanceCostModal] = useState<boolean>(false);
  const [showFinanceCostViewModal, setShowFinanceCostViewModal] = useState<boolean>(false);
  const [financeCostData, setFinanceCostData] = useState<FinanceCost | null>(null);
  const [financeTotalCost, setFinanceTotalCost] = useState<number>(0);

  /* Form field */
  const [financeAmount, setFinanceAmount] = useState<number | null>(0);
  const [interestRate, setInterestRate] = useState<number | null>(0);
  const [loanMonth, setLoanMonth] = useState<number | null>(0);
  const [interestAmount, setInterestAmount] = useState<number | null>(0);
  const [arrangementFee, setArrangementFee] = useState<number | null>(0);
  const [existFee, setExistFee] = useState<number | null>(0);
  const [lawyerFee, setLawyerFee] = useState<number | null>(0);

  const [financeCostUpdateHasChanges, setFinanceCostUpdateHasChanges] = useState<boolean>(false);
  const [isFinanceCostCreateDisabled, setIsFinanceCostCreateDisabled] = useState<boolean>(false);
  /* ****************************************************************************** */

  /* ****************************** For land cost ****************************** */
  const [showLandCostModal, setShowLandCostModal] = useState<boolean>(false);
  const [showLandCostViewModal, setShowLandCostViewModal] = useState<boolean>(false);
  const [landCostData, setLandCostData] = useState<LandCost | null>(null);
  const [landTotalCost, setLandTotalCost] = useState<number>(0);

  /* Form field */
  const [landPurchasePrice, setLandPurchasePrice] = useState<number | null>(0);
  const [landFee, setLandFee] = useState<number | null>(0);
  const [stampDutyFee, setStampDutyFee] = useState<number | null>(0);
  const [landLawyerFee, setLandLawyerFee] = useState<number | null>(0);

  const [landCostUpdateHasChanges, setLandCostUpdateHasChanges] = useState<boolean>(false);
  const [isLandCostCreateDisabled, setIsLandCostCreateDisabled] = useState<boolean>(false);
  /* ****************************************************************************** */

  /* ******************************** For other cost ****************************** */
  const [appraisalId, setAppraisalId] = useState<number>(0);
  const [appraisalName, setAppraisalName] = useState<string>("");

  const [showOtherCostModal, setShowOtherCostModal] = useState<boolean>(false);
  const [showOtherCostViewModal, setShowOtherCostViewModal] = useState<boolean>(false);
  const [otherCostData, setOtherCostData] = useState<OtherCost[]>([]);
  const [otherTotalCost, setOtherTotalCost] = useState<number>(0);
  const [showMoreAdd, setShowMoreAdd] = useState<boolean>(false);

  const [otherCostUpdateHasChanges, setOtherCostUpdateHasChanges] = useState<boolean>(false);
  const [isOtherCostCreateDisabled, setIsOtherCostCreateDisabled] = useState<boolean>(false);
  const [deletingIndex, setDeletingIndex] = useState<number | null>(null);

  /* Form field */
  const [otherCostTitle, setOtherCostTitle] = useState<string>("");
  const [otherCostAmount, setOtherCostAmount] = useState<number>(0);

  /* Error */
  const [otherCostError, setOtherCostError] = useState<string>("");
  /* ****************************************************************************** */


  // PERMISION HANDLER
  const useCanEdit = (screen: string, permission: string) => {
    return useSelector((state: RootState) =>
      hasPermission(state, screen, permission)
    );
  };

  const edit_data = useCanEdit("Development appraisal", "edit_development_appraisal");
  const delete_data = useCanEdit("Development appraisal", "delete_development_appraisal");
  const add_basic_cost = useCanEdit("Development appraisal", "add_basic_cost");
  const add_detail_cost = useCanEdit("Development appraisal", "add_details_cost");
  const edit_detail_cost = useCanEdit("Development appraisal", "edit_details_cost");
  const delete_detail_cost = useCanEdit("Development appraisal", "delete_details_cost");


  //  change real time responce with updated project info
  useEffect(() => {
    if (location.state && location.state.folderId) {
      const folder_id = location.state.folderId as number;
      setFolderId(folder_id);
    }

    if (location.state && location.state.data) {
      const folder = location.state.data as any;
      setFolderData(folder);
      setSharedBy(folder.sharedBy);
    }
  }, [location.state]);

  useEffect(() => {
    const savedTab = localStorage.getItem("activeCostTab");
    if (savedTab === "detail" || savedTab === "basic") {
      setViewState(savedTab as "basic" | "detail");
    }
  }, []);

  //   get from data base and set data to here
  // for the resons
  const dispatch = useAppDispatch();

  // for fetching data fro api tigger with state object actions
  useEffect(() => {
    developmentAppraisalDataGet();
  }, [folderId]);


  const developmentAppraisalDataGet = async () => {
    if (folderId) {
      await dispatch(getAllDevelopmentAppraisalList(folderId));
      setInitialDataLoading(false);
    }
  }

  // this is get data from state list and set projectlist
  const developmentAppraisalDataList = useAppSelector(
    (state) => state.developmetAppraisalList.developmentAppraisalList
  );

  //   initially set values both
  useEffect(() => {
    if (developmentAppraisalDataList && developmentAppraisalDataList.length > 0) {
      setDevelopmentAppraisalData(developmentAppraisalDataList);
      //   setCostValues(developmentAppraisalDataList);
    }
  }, [developmentAppraisalDataList]);

  useEffect(() => {
    const totalAmount = developmentAppraisalData.reduce(
      (acc, item) => acc + (item?.amount || 0),
      0
    );
    setBasicCostTotalAmount(totalAmount);

    // need to restore finace cost.
    const finace = developmentAppraisalData.filter(
      (e) =>
        e.development_appraisal?.appraisal_name.toLocaleLowerCase() ===
        "finance cost"
    );

    if (finace && finace.length > 0) {
      setFinanceCostData(finace[0].development_appraisal_finance_cost!);
    }

    const land = developmentAppraisalData.filter(
      (e) =>
        e.development_appraisal?.appraisal_name.toLocaleLowerCase() ===
        "land cost"
    );

    if (land && land.length > 0) {
      setLandCostData(land[0].development_appraisal_land_cost!);
    }
  }, [developmentAppraisalData]);

  useEffect(() => {
    if (developmentAppraisalData && developmentAppraisalData.length > 0) {
      const options = developmentAppraisalData.reduce(
        (accumulator, currentValue) => accumulator + currentValue?.amount!,
        0
      );

      setShowBasicCostDetail(options > 0);
      setCostValues(developmentAppraisalData);
    }
  }, [developmentAppraisalData]);

  const handleTabChange = (tab: "basic" | "detail") => {
    setViewState(tab);
    localStorage.setItem("activeCostTab", tab);
  };

  /* ****************************** For basic cost ******************************* */
  const handleCostChange = (value: number, id: number) => {
    //  here our logig need to applay.
    const dataCollection: any = costValues?.map((data) => {
      // Extract the first template as selectedTemplate or null if no template data exists
      if (data.id === id) {
        return {
          id: data.id,
          folder_id: data.folder_id,
          development_appraisal_id: data.development_appraisal_id,
          amount: value,
          development_appraisal_gdv_sum_total_price: data.development_appraisal_gdv_sum_total_price,
          development_appraisal_other_sum_amount: data.development_appraisal_other_sum_amount,
          development_appraisal_finance_cost_sum_finance_amount: data.development_appraisal_finance_cost_sum_finance_amount,
          development_appraisal_land_cost_sum_purchase_price: data.development_appraisal_land_cost_sum_purchase_price,
          development_appraisal: data.development_appraisal,
          development_appraisal_gdv: data.development_appraisal_gdv,
          development_appraisal_other: data.development_appraisal_other,
          development_appraisal_finance_cost: data.development_appraisal_finance_cost,
          development_appraisal_land_cost: data.development_appraisal_land_cost,
        };
      } else {
        return data;
      }
    });
    setCostValues(mapDevelopmentAppraisalDataLists(dataCollection));
  };

  const handleCreateBasicCost = async (e: React.FormEvent) => {
    e.preventDefault();

    //save action and tigger data
    if (costValues && costValues.length > 0) {
      setLoading(true);
      const data = await addDevelopmentAppraisal(costValues);

      setLoading(false);

      if (data.statusCode === 200) {
        // call dispach event
        developmentAppraisalDataGet();
        setShowBasicCostDetail(true);

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Basic cost details added successfully.",
            life: 3000,
          });
        }
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error creating the basic cost detail.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleEditBasicCost = () => {
    setShowBasicCostModal(true);
  };

  useEffect(() => {
    if (developmentAppraisalData && costValues) {
      if (costValues.some(val => val?.amount === null)) {
        setBasicCostUpdateHasChanges(false);
        return;
      }

      const hasChanges =
        costValues.length !== developmentAppraisalData.length ||
        costValues.some((val, idx) => val?.amount !== developmentAppraisalData[idx]?.amount);

      setBasicCostUpdateHasChanges(hasChanges);
    }
  }, [developmentAppraisalData, costValues]);

  const handleUpdateBasicCost = async (e: React.FormEvent) => {
    e.preventDefault();

    if (costValues && costValues.length > 0) {
      setUpdateLoading(true);
      const data = await addDevelopmentAppraisal(costValues);

      setUpdateLoading(false);
      if (data.statusCode === 200) {
        // call shop dispach event
        developmentAppraisalDataGet();
        handleCloseBasicCostModal();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Basic cost details updated successfully.",
            life: 3000,
          });
        }
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error updating the basic cost detail.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleCloseBasicCostModal = () => {
    setShowBasicCostModal(false);
  };

  // finance calculations
  useEffect(() => {
    const value = ((financeAmount || 0) * (interestRate || 0) / 100) * (loanMonth || 0);
    setInterestAmount(value);
  }, [financeAmount, interestRate, loanMonth]);


  //   remove basic cost
  const handleRemoveBasicCost = (cost: DevelopmentAppraisalDataList) => {
    confirmDialog({
      message: (
        <div className="text-center d-flex justify-content-center flex-column">
          <span>
            Are you sure you want to remove the <b>{(cost?.development_appraisal?.appraisal_name)?.toLowerCase()}</b> detail?<br />
          </span>
        </div>
      ),
      header: "Confirmation of removal",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      accept: () => removeBasicCost(cost?.id!),
      dismissableMask: true,
      draggable: false,
      resizable: false,
    });
  };

  //   delete basic informations.
  const removeBasicCost = async (id: number) => {
    setBasicCostDeleteLoadingId(id);
    const result = await deleteDevelopmentAppraisal(id);

    setBasicCostDeleteLoadingId(null);
    if (result.statusCode === 200) {
      developmentAppraisalDataGet();
      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Basic cost record deleted successfully.",
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error deleting the basic cost record.",
          life: 3000,
        });
      }
    }
  };

  const basicCostModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Edit basic cost</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseBasicCostModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const basicCostModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseBasicCostModal}
      />

      <Button
        label={updateLoading ? "Processing" : "Update"}
        onClick={handleUpdateBasicCost}
        loading={updateLoading}
        className="custom_btn primary"
        disabled={!basicCostUpdateHasChanges}
      />
    </div>
  );
  /* ****************************************************************************** */

  /* ****************************** For detail cost ******************************* */
  const addDataBody = (rowData: DevelopmentAppraisalDataList) => {
    let hasData = false;
    const appraisalName = rowData?.development_appraisal?.appraisal_name;
    const gdvData = rowData?.development_appraisal_gdv;
    const otherData = rowData?.development_appraisal_other;
    const financeData = rowData?.development_appraisal_finance_cost;
    const landData = rowData?.development_appraisal_land_cost;

    if (appraisalName === "GDV cost" && gdvData?.length !== 0) {
      hasData = true;
    } else if (appraisalName === "Construction cost" && otherData?.length !== 0) {
      hasData = true;
    } else if (appraisalName === "Professional fee" && otherData?.length !== 0) {
      hasData = true;
    } else if (appraisalName === "Finance cost" && financeData !== null) {
      hasData = true;
    } else if (appraisalName === "Land cost" && landData !== null) {
      hasData = true;
    } else if (appraisalName === "Other cost" && otherData?.length !== 0) {
      hasData = true;
    }

    const goToCostDetails = (costName: string) => {
      if (costName === "GDV cost") {
        navigate(
          `/project/detail/default-service/general/development-appraisal/gdv-cost`,
          {
            state: {
              data: gdvData,
              folderId: folderId,
              appraisalData: rowData,
              shared_by: sharedBy,
              folder_data: folderData
            },
          }
        );
      } else if (costName === "Construction cost") {
        handleAddOtherCost(costName, (otherData && otherData) || [], rowData.id!);
      } else if (costName === "Professional fee") {
        handleAddOtherCost(costName, (otherData && otherData) || [], rowData.id!);
      } else if (costName === "Finance cost") {
        handleAddFinanceCost(rowData?.id!);
      } else if (costName === "Land cost") {
        handleAddLandCost(rowData?.id!);
      } else if (costName === "Other cost") {
        handleAddOtherCost(costName, (otherData && otherData) || [], rowData.id!);
      }
    };

    return (
      <React.Fragment>
        {hasData ? (
          <span className="text_purple text_bold">Added</span>
        ) : (
          <React.Fragment>
            {add_detail_cost && !isShared ? (
              <button
                type="button"
                className={`add_data_btn custom p-ripple`}
                onClick={() => goToCostDetails(appraisalName!)}
              >
                <i className={`bi bi-plus-circle`}></i>
                <span>Add {appraisalName?.toLowerCase()}</span>
                <Ripple />
              </button>
            ) : (
              <span className="text-secondary text_italic">
                <i className="bi bi-exclamation-circle me-1"></i>
                Not added!
              </span>
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  };

  const amountDataBody = (rowData: DevelopmentAppraisalDataList) => {
    let totalAmount = 0;
    const appraisalName = rowData?.development_appraisal?.appraisal_name;

    if (appraisalName === "GDV cost") {
      totalAmount = rowData?.development_appraisal_gdv_sum_total_price || 0;
    } else if (appraisalName === "Construction cost") {
      totalAmount = rowData?.development_appraisal_other_sum_amount || 0;
    } else if (appraisalName === "Professional fee") {
      totalAmount = rowData?.development_appraisal_other_sum_amount || 0;
    } else if (appraisalName === "Finance cost") {
      totalAmount =
        rowData?.development_appraisal_finance_cost_sum_finance_amount || 0;
    } else if (appraisalName === "Land cost") {
      totalAmount =
        rowData?.development_appraisal_land_cost_sum_purchase_price || 0;
    } else if (appraisalName === "Other cost") {
      totalAmount = rowData?.development_appraisal_other_sum_amount || 0;
    }

    return (
      <span className="text-center flex_center text_bold">
        {currencySymbol}&nbsp;{formatAmount(totalAmount)}
      </span>
    );
  };

  const viewDataBody = (rowData: DevelopmentAppraisalDataList) => {
    let optionDisabled = false;
    const appraisalName = rowData?.development_appraisal?.appraisal_name;
    const gdvData = rowData?.development_appraisal_gdv;
    const otherData = rowData?.development_appraisal_other;
    const financeData = rowData?.development_appraisal_finance_cost;
    const landData = rowData?.development_appraisal_land_cost;

    const financeCostTotal = rowData?.development_appraisal_finance_cost_sum_finance_amount || 0;
    const landCostTotal = rowData?.development_appraisal_land_cost_sum_purchase_price || 0;
    const otherCostTotal = rowData?.development_appraisal_other_sum_amount || 0;

    if (appraisalName === "GDV cost" && gdvData?.length === 0) {
      optionDisabled = true;
    } else if (appraisalName === "Construction cost" && otherData?.length === 0) {
      optionDisabled = true;
    } else if (appraisalName === "Professional fee" && otherData?.length === 0) {
      optionDisabled = true;
    } else if (appraisalName === "Finance cost" && financeData === null) {
      optionDisabled = true;
    } else if (appraisalName === "Land cost" && landData === null) {
      optionDisabled = true;
    } else if (appraisalName === "Other cost" && otherData?.length === 0) {
      optionDisabled = true;
    }

    const goToCostDetails = (costName: string) => {
      if (costName === "GDV cost") {
        navigate(
          `/project/detail/default-service/general/development-appraisal/gdv-cost`,
          {
            state: {
              data: gdvData,
              folderId: folderId,
              appraisalData: rowData,
              shared_by: sharedBy,
              folder_data: folderData
            },
          }
        );
      } else if (costName === "Construction cost") {
        handleViewOtherCost(costName, otherData ? otherData : [], rowData.id!);
        setOtherTotalCost(otherCostTotal);
      } else if (costName === "Professional fee") {
        handleViewOtherCost(costName, otherData ? otherData : [], rowData.id!);
        setOtherTotalCost(otherCostTotal);
      } else if (costName === "Finance cost") {
        handleViewFinanceCost(financeData || null, rowData.id!);
        setFinanceTotalCost(financeCostTotal);
      } else if (costName === "Land cost") {
        handleViewLandCost(landData || null, rowData.id!);
        setLandTotalCost(landCostTotal);
      } else if (costName === "Other cost") {
        handleViewOtherCost(costName, otherData ? otherData : [], rowData.id!);
        setOtherTotalCost(otherCostTotal);
      }
    };

    return (
      <div className="table_action_btn_area">
        <button
          className="tabel_btn p-ripple"
          disabled={optionDisabled}
          onClick={() => goToCostDetails(appraisalName!)}
        >
          View
          <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
        </button>
      </div>
    );
  };
  /* ****************************************************************************** */

  /* ****************************** For finance cost ******************************* */
  const handleCloseFinanceCostModal = () => {
    setShowFinanceCostModal(false);
    handleClearFinanceCostFields();
  };

  const handleClearFinanceCostFields = () => {
    setFinanceAmount(0);
    setInterestRate(0);
    setLoanMonth(0);
    setInterestAmount(0);
    setArrangementFee(0);
    setExistFee(0);
    setLawyerFee(0);
  };

  const handleAddFinanceCost = (id: number) => {
    setShowFinanceCostModal(true);
    setDataState("Add");
    setAppraisalId(id);
  };

  useEffect(() => {
    const fields = [
      financeAmount,
      interestRate,
      loanMonth,
      interestAmount,
      arrangementFee,
      existFee,
      lawyerFee,
    ];

    setIsFinanceCostCreateDisabled(fields.some(field => field === null));
  }, [financeAmount, interestRate, loanMonth, interestAmount, arrangementFee, existFee, lawyerFee]);


  const handleCreateFinanceCost = async (e: React.FormEvent) => {
    e.preventDefault();

    setLoading(true);

    const data = await addFinanceCost(
      appraisalId!,
      financeAmount || 0,
      interestRate || 0,
      loanMonth || 0,
      interestAmount || 0,
      arrangementFee || 0,
      existFee || 0,
      lawyerFee || 0
    );

    setLoading(false);
    if (data.statusCode === 200) {
      // call shop dispach event
      developmentAppraisalDataGet();
      handleCloseFinanceCostModal();

      if (toast.current) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: `Finance cost added successfully.`,
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error creating finance cost detail",
          life: 3000,
        });
      }
    }
  };

  const handleEditFinanceCost = (data: FinanceCost) => {
    setShowFinanceCostModal(true);
    setDataState("Edit");

    if (data && data !== null) {
      setFinanceAmount(data.finance_amount);
      setInterestRate(data.interest_rate);
      setLoanMonth(data.loan_month);
      setInterestAmount(data.interest);
      setArrangementFee(data.arrangement_fees);
      setExistFee(data.exist_fees);
      setLawyerFee(data.lawyer_fees);
    } else {
      handleClearFinanceCostFields();
    }
  };

  useEffect(() => {
    if (financeCostData) {
      if (financeAmount !== null && financeAmount !== financeCostData?.finance_amount) {
        setFinanceCostUpdateHasChanges(true);
      } else if (interestRate !== null && interestRate !== financeCostData?.interest_rate) {
        setFinanceCostUpdateHasChanges(true);
      } else if (loanMonth !== null && loanMonth !== financeCostData?.loan_month) {
        setFinanceCostUpdateHasChanges(true);
      } else if (interestAmount !== null && interestAmount !== financeCostData?.interest) {
        setFinanceCostUpdateHasChanges(true);
      } else if (arrangementFee !== null && arrangementFee !== financeCostData?.arrangement_fees) {
        setFinanceCostUpdateHasChanges(true);
      } else if (existFee !== null && existFee !== financeCostData?.exist_fees) {
        setFinanceCostUpdateHasChanges(true);
      } else if (lawyerFee !== null && lawyerFee !== financeCostData?.lawyer_fees) {
        setFinanceCostUpdateHasChanges(true);
      } else {
        setFinanceCostUpdateHasChanges(false);
      }
    }
  }, [
    financeCostData,
    financeAmount,
    interestRate,
    loanMonth,
    interestAmount,
    arrangementFee,
    existFee,
    lawyerFee,
  ]);

  const handleUpdateFinanceCost = async (e: React.FormEvent) => {
    e.preventDefault();

    setLoading(true);
    const data = await addFinanceCost(
      appraisalId!,
      financeAmount || 0,
      interestRate || 0,
      loanMonth || 0,
      interestAmount || 0,
      arrangementFee || 0,
      existFee || 0,
      lawyerFee || 0
    );
    setLoading(false);
    if (data.statusCode === 200) {
      // call shop dispach event
      developmentAppraisalDataGet();
      handleCloseFinanceCostModal();

      if (toast.current) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: `Finance cost updated successfully.`,
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error updating finance cost detail",
          life: 3000,
        });
      }
    }
  };

  const financeCostModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">{dataState}&nbsp;finance cost detail</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseFinanceCostModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const financeCostModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseFinanceCostModal}
      />
      <Button
        label={loading ? "Processing" : dataState === "Add" ? "Save" : "Update"}
        onClick={dataState === "Add" ? handleCreateFinanceCost : handleUpdateFinanceCost}
        loading={loading}
        className="custom_btn primary"
        disabled={(dataState === 'Edit' && !financeCostUpdateHasChanges) || (dataState === 'Add' && isFinanceCostCreateDisabled)}
      />
    </div>
  );

  const handleViewFinanceCost = (data: FinanceCost | null, id: number) => {
    setShowFinanceCostViewModal(true);
    setFinanceCostData(data);
    setAppraisalId(id);
  };

  const handleCloseFinanceCostViewModal = () => {
    setShowFinanceCostViewModal(false);
    setFinanceCostData(null);
  };
  /* ****************************************************************************** */

  /* ******************************** For land cost ******************************* */
  const handleCloseLandCostModal = () => {
    setShowLandCostModal(false);
    handleClearLandCostFields();
  };

  const handleClearLandCostFields = () => {
    setLandPurchasePrice(0);
    setLandFee(0);
    setStampDutyFee(0);
    setLandLawyerFee(0);
  };

  const handleAddLandCost = (id: number) => {
    setShowLandCostModal(true);
    setDataState("Add");
    setAppraisalId(id);
  };

  useEffect(() => {
    const fields = [
      landPurchasePrice,
      landFee,
      stampDutyFee,
      landLawyerFee,
    ];

    setIsLandCostCreateDisabled(fields.some(field => field === null));
  }, [landPurchasePrice, landFee, stampDutyFee, landLawyerFee]);

  const handleCreateLandCost = async (e: React.FormEvent) => {
    e.preventDefault();

    setLoading(true);
    const data = await addLandCost(
      appraisalId!,
      landPurchasePrice || 0,
      landFee || 0,
      stampDutyFee || 0,
      landLawyerFee || 0
    );
    setLoading(false);
    if (data.statusCode === 200) {
      // call shop dispach event
      developmentAppraisalDataGet();
      handleCloseLandCostModal();

      if (toast.current) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: `Land cost added successfully.`,
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error creating land cost detail",
          life: 3000,
        });
      }
    }
  };

  const handleEditLandCost = (data: LandCost) => {
    setShowLandCostModal(true);
    setDataState("Edit");

    if (data && data !== null) {
      setLandPurchasePrice(data.purchase_price);
      setLandFee(data.fees);
      setStampDutyFee(data.stamp_duty);
      setLandLawyerFee(data.lawyer_fees);
    } else {
      handleClearLandCostFields();
    }
  };

  useEffect(() => {
    if (landCostData) {
      if (landPurchasePrice !== null && landPurchasePrice !== landCostData?.purchase_price) {
        setLandCostUpdateHasChanges(true);
      } else if (landFee !== null && landFee !== landCostData?.fees) {
        setLandCostUpdateHasChanges(true);
      } else if (stampDutyFee !== null && stampDutyFee !== landCostData?.stamp_duty) {
        setLandCostUpdateHasChanges(true);
      } else if (landLawyerFee !== null && landLawyerFee !== landCostData?.lawyer_fees) {
        setLandCostUpdateHasChanges(true);
      } else {
        setLandCostUpdateHasChanges(false);
      }
    }
  }, [
    landCostData,
    landPurchasePrice,
    landFee,
    stampDutyFee,
    landLawyerFee,
  ]);

  // update function
  const handleUpdateLandCost = async (e: React.FormEvent) => {
    e.preventDefault();

    setLoading(true);
    const data = await addLandCost(
      appraisalId!,
      landPurchasePrice || 0,
      landFee || 0,
      stampDutyFee || 0,
      landLawyerFee || 0
    );
    setLoading(false);
    if (data.statusCode === 200) {
      // call shop dispach event
      developmentAppraisalDataGet();
      handleCloseLandCostModal();

      if (toast.current) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: `Land cost updated successfully.`,
          life: 3000,
        });
      }
    } else {
      setLoading(false);
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error updating land cost detail",
          life: 3000,
        });
      }
    }
  };

  const landCostModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">{dataState}&nbsp;land cost detail</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseLandCostModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const landCostModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseLandCostModal}
      />
      <Button
        label={loading ? "Processing" : dataState === "Add" ? "Save" : "Update"}
        onClick={dataState === "Add" ? handleCreateLandCost : handleUpdateLandCost}
        loading={loading}
        className="custom_btn primary"
        disabled={(dataState === 'Edit' && !landCostUpdateHasChanges) || (dataState === 'Add' && isLandCostCreateDisabled)}
      />
    </div>
  );

  const handleViewLandCost = (data: LandCost | null, id: number) => {
    setAppraisalId(id);
    setShowLandCostViewModal(true);
    setLandCostData(data);
  };

  const handleCloseLandCostViewModal = () => {
    setShowLandCostViewModal(false);
    setLandCostData(null);
  };
  /* ****************************************************************************** */

  /* ******************************* For other cost ******************************* */
  const handleCloseOtherCostModal = () => {
    setShowOtherCostModal(false);
    handleClearOtherCostFields();
    handleClearOtherCostErrors();
  };

  const handleClearOtherCostFields = () => {
    setOtherCostTitle("");
    setOtherCostAmount(0);
  };

  const handleClearOtherCostErrors = () => {
    setOtherCostError("");
  };

  const handleAddOtherCost = (title: string, data: OtherCost[], id: number) => {
    setDataState("Add");
    setOtherCostData(data);
    setShowOtherCostModal(true);

    setAppraisalName(title);
    setAppraisalId(id);
  };

  useEffect(() => {
    if (otherCostTitle !== null && otherCostAmount !== null) {
      setOtherCostError('');
    }
  }, [otherCostTitle, otherCostAmount]);

  // tempary add det, ails.
  const handleAddMoreCost = () => {
    if (otherCostTitle.trim() && otherCostAmount !== null) {
      handleClearOtherCostErrors();

      const newCost: OtherCost = {
        id: null,
        name: otherCostTitle.trim(),
        amount: otherCostAmount,
        is_default: 0,
      };

      setOtherCostData([...otherCostData, newCost]);
      setOtherCostTitle("");
      setOtherCostAmount(0);
    } else {
      setOtherCostError("Please enter the cost details.");
    }
  };

  const handleDeleteCost = (index: number, id: number | null) => {
    confirmDialog({
      message: `Are you sure you want to remove the cost detail?`,
      header: "Confirmation of removal",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      accept: () => deleteCost(index, id),
      dismissableMask: true,
      draggable: false,
      resizable: false,
    });
  };

  const handleRemoveCost = () => {
    setOtherCostTitle("");
    setOtherCostAmount(0);
    setOtherCostError("");
    setShowMoreAdd(false);
  };


  const deleteCost = async (index: number, id: number | null) => {
    if (id === null) {
      const updatedCosts = otherCostData.filter((_, i) => i !== index);
      setOtherCostData(updatedCosts);
      return;
    }

    setDeletingIndex(index);

    try {
      const result = await deleteOtherCostData(id);

      if (result.statusCode === 200) {
        const updatedCosts = otherCostData.filter((_, i) => i !== index);
        setOtherCostData(updatedCosts);

        if (updatedCosts.length === 0) {
          handleCloseOtherCostModal();
          handleCloseOtherCostViewModal();
        }

        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: "Cost data deleted successfully.",
          life: 3000,
        });

        developmentAppraisalDataGet();
      } else {
        toast.current?.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error deleting cost data.",
          life: 3000,
        });
      }
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Something went wrong while deleting cost data.",
        life: 3000,
      });
    } finally {
      setDeletingIndex(null);
    }
  };

  useEffect(() => {
    if (otherCostTitle.trim() === "" || otherCostAmount === null) {
      setIsOtherCostCreateDisabled(true);
    } else {
      setIsOtherCostCreateDisabled(false);
    }
  }, [otherCostTitle, otherCostAmount]);

  useEffect(() => {
    if (appraisalId !== null && developmentAppraisalData?.length > 0) {
      const updatedData = developmentAppraisalData.find(
        (data) => data.id === appraisalId
      );
      setOtherCostData(updatedData?.development_appraisal_other || []);
    }
  }, [developmentAppraisalData, appraisalId]);


  // insert data into data base.
  const handleCreateOtherCost = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!otherCostTitle.trim() || otherCostAmount === null) return;

    const newCost: OtherCost = {
      id: null,
      name: otherCostTitle.trim(),
      amount: otherCostAmount,
      is_default: 0,
    };

    const updatedOtherCosts = [...otherCostData, newCost];

    setLoading(true);
    const data = await addOtherCost(appraisalId!, updatedOtherCosts);
    setLoading(false);
    if (data.statusCode === 200) {
      // call shop dispach event
      developmentAppraisalDataGet();
      handleCloseOtherCostModal();

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: `${appraisalName} added successfully.`,
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error creating cost detail",
          life: 3000,
        });
      }
    }
  };

  const handleEditOtherCost = (data: OtherCost[]) => {
    setDataState("Edit");
    setShowOtherCostModal(true);
  };

  useEffect(() => {
    if (!otherCostData || !appraisalId) return;

    const originalData =
      developmentAppraisalData?.find(a => a.id === appraisalId)?.development_appraisal_other || [];

    if (otherCostData.length !== originalData.length) {
      setOtherCostUpdateHasChanges(true);
      return;
    }

    if (showMoreAdd && otherCostTitle.trim() !== "" && otherCostAmount !== null) {
      setOtherCostUpdateHasChanges(true);
      return;
    }

    const hasChanges = otherCostData.some((cost, idx) => {
      const original = originalData[idx];
      return (
        cost?.id !== original?.id ||
        cost?.name !== original?.name ||
        cost?.amount !== original?.amount ||
        cost?.is_default !== original?.is_default
      );
    });

    setOtherCostUpdateHasChanges(hasChanges);
  }, [
    otherCostData,
    appraisalId,
    developmentAppraisalData,
    showMoreAdd,
    otherCostTitle,
    otherCostAmount,
  ]);

  const handleUpdateOtherCost = async (e: React.FormEvent) => {
    e.preventDefault();

    let updatedOtherCosts = [...otherCostData];

    if (otherCostTitle.trim() !== "" && otherCostAmount !== null) {
      const newCost: OtherCost = {
        id: null,
        name: otherCostTitle.trim(),
        amount: otherCostAmount,
        is_default: 0,
      };
      updatedOtherCosts = [...updatedOtherCosts, newCost];
    }

    if (updatedOtherCosts.length === 0) return;

    setLoading(true);
    const data = await addOtherCost(appraisalId!, updatedOtherCosts);

    setLoading(false);
    if (data.statusCode === 200) {
      // call shop dispach event
      developmentAppraisalDataGet();
      handleCloseOtherCostModal();

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: `${appraisalName} updated successfully.`,
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error updating cost detail",
          life: 3000,
        });
      }
    }
  };

  const otherCostModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">
        {dataState}&nbsp;<span className="text-lowercase">{appraisalName}</span>{" "}
        detail
      </h5>

      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseOtherCostModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const otherCostModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseOtherCostModal}
      />

      <Button
        label={loading ? "Processing" : dataState === "Add" ? "Save" : "Update"}
        onClick={dataState === "Add" ? handleCreateOtherCost : handleUpdateOtherCost}
        loading={loading}
        className="custom_btn primary"
        disabled={
          (dataState === "Edit" && !otherCostUpdateHasChanges) ||
          (dataState === "Add" && isOtherCostCreateDisabled)
        }
      />
    </div>
  );

  const handleViewOtherCost = (
    title: string,
    data: OtherCost[],
    id: number
  ) => {
    setOtherCostData(data);
    setAppraisalName(title);
    setAppraisalId(id);
    setShowOtherCostViewModal(true);
  };

  const handleCloseOtherCostViewModal = () => {
    setShowOtherCostViewModal(false);
    setOtherCostData([]);
  };

  const handleToggleShowMore = () => {
    setShowMoreAdd(true);
  };
  /* ****************************************************************************** */

  /* Common function */
  const formatAmount = (amount: number): string => {
    return amount.toFixed(2);
  };

  const goBack = () => {
    navigate(-1);
    goToTop();
  };
  /*  */

  return (
    <React.Fragment>
      <Toast ref={toast} />

      <div className="main_content layout_padding show_side_bar">
        {dataLoading && initialDataloading ? (
          <PageLoader />
        ) : errorMessage ? (
          <ErrorPage errorMessage={errorMessage} />
        ) : (
          <div className="page_content mt-0">
            <div className="page_breadcrumb_area">
              <ul className="page_breadcrumb">
                <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                  {projectData?.job_number + `: ` + projectData?.address}
                </li>
                <li className="page_breadcrumb_item has_child">
                  {projectData.folder}
                </li>
                <li className="page_breadcrumb_item active">
                  {projectData.feature_name}
                </li>
              </ul>

              <button className="back_btn p-ripple" onClick={goBack}>
                <i className="bi bi-arrow-left me-2"></i>
                Back
                <Ripple />
              </button>
            </div>

            {developmentAppraisalData && developmentAppraisalData?.length > 0 ? (
              <React.Fragment>
                <div className="page_header_area mt-3">
                  <div className="contact_tabs_container">
                    <ul
                      className="contact_tabs mb-3"
                      id="project-tabs"
                      role="tablist"
                    >
                      <li className="contact_tab_item" role="presentation">
                        <button
                          className={`contact_tab_btn p-ripple ${viewState === "basic" ? "active" : ""}`}
                          onClick={() => handleTabChange("basic")}
                          id="basic-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#basic"
                          type="button"
                          role="tab"
                          aria-controls="basic"
                          aria-selected={viewState === "basic" ? true : false}
                        >
                          Basic
                          <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                        </button>
                      </li>
                      <li className="contact_tab_item" role="presentation">
                        <button
                          className={`contact_tab_btn p-ripple ${viewState === "detail" ? "active" : ""}`}
                          onClick={() => handleTabChange("detail")}
                          id="detail-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#detail"
                          type="button"
                          role="tab"
                          aria-controls="detail"
                          aria-selected={viewState === "detail" ? true : false}
                        >
                          Detail
                          <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  className="tab-content contact_tab_content"
                  id="project-tabsContent"
                >
                  {/* Basic cost view */}
                  <div
                    className={`tab-pane fade ${viewState === "basic" ? "show active" : ""}`}
                    id="basic"
                    role="tabpanel"
                    aria-labelledby="basic-tab"
                    tabIndex={0}
                  >
                    <div className="page_main_content_section">
                      <div className="cost_detail_section">
                        <div className="cost_detail_container">
                          <h6 className="cost_detail_head">
                            Basic cost detail
                          </h6>
                          <div className="row">
                            {showBasicCostDetail ? (
                              <React.Fragment>
                                {/* View */}
                                <div className="col-12 col-xxl-8 col-xl-7 d-none d-xl-block">
                                  <div className="add_cost_section">
                                    {developmentAppraisalData?.map(
                                      (cost, index) => {
                                        return (
                                          <div
                                            key={cost?.id}
                                            className="row mb-sm-3 mb-2"
                                          >
                                            <div className="col-xxl-6 col-8 pe-sm-2 pe-1">
                                              <div className="cost_title_grp">
                                                <span>{index + 1}.</span>
                                                <label
                                                  htmlFor="gdvCost"
                                                  className="cost_title"
                                                >
                                                  {cost?.development_appraisal?.appraisal_name}
                                                </label>
                                              </div>
                                            </div>
                                            <div className="col-4 ps-sm-2 ps-1">
                                              <label
                                                htmlFor="gdvCost"
                                                className="cost_value"
                                              >
                                                {currencySymbol}&nbsp;
                                                <span>
                                                  {formatAmount(cost?.amount!)}
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-xxl-4 col-xl-5 mt-2 mt-xl-0">
                                  <article className="cost_view_container">
                                    <div className="cost_view_header">

                                      {(edit_data && !isShared) && (
                                        <button
                                          className="data_action_btn cost_edit_btn float p-ripple"
                                          onClick={handleEditBasicCost}
                                        >
                                          <i className="bi bi-pencil-square"></i>
                                          <Ripple />
                                        </button>
                                      )}

                                      <div className="cost_total_area">
                                        <h5>Basic cost</h5>
                                        <h5>
                                          {currencySymbol}&nbsp;
                                          {formatAmount(basicCostTotalAmount)}
                                        </h5>
                                      </div>
                                    </div>
                                    <div className="cost_view_body">
                                      {developmentAppraisalData?.map((cost) => {
                                        return (
                                          <div
                                            key={cost?.id}
                                            className="cost_view_data_area"
                                          >
                                            <h6 className="cost_view_title">
                                              {cost?.development_appraisal?.appraisal_name}
                                            </h6>
                                            <h6 className="cost_view_value">
                                              {currencySymbol}&nbsp;
                                              {formatAmount(cost?.amount!)}
                                            </h6>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </article>
                                </div>
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                {/* Create */}
                                <div className="col-12 col-xxl-8 col-xl-7">
                                  <div className="add_cost_section">
                                    {costValues?.map((cost, index) => {
                                      return (
                                        <div
                                          key={`second_${cost?.id}`}
                                          className="row mb-sm-3 mb-2"
                                        >
                                          <div className="col-xxl-6 col-8 pe-sm-2 pe-1">
                                            <div className="cost_title_grp">
                                              <span>{index + 1}.</span>
                                              <label
                                                htmlFor={`basicCost-${index}`}
                                                className="cost_title"
                                              >
                                                {cost?.development_appraisal?.appraisal_name}
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-4 ps-sm-2 ps-1">
                                            <InputNumber
                                              inputId={`basicCost-${index}`}
                                              value={cost?.amount}
                                              // value={0}
                                              onValueChange={(e) => handleCostChange(e.value || 0, cost?.id!)}
                                              minFractionDigits={2}
                                              maxFractionDigits={2}
                                              mode="currency"
                                              currency="GBP"
                                              locale="en-UK"
                                              className="cost_input"
                                              placeholder={currencySymbol + "0.00"}
                                              disabled={isShared && !add_basic_cost}
                                            />
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>

                                {!isShared && add_basic_cost && (
                                  <div className="col-12">
                                    <div className="cost_detail_footer">
                                      <Button
                                        label={`${loading ? "Processing" : "Save"}`}
                                        className="form_btn"
                                        loading={loading}
                                        onClick={handleCreateBasicCost}
                                        disabled={costValues?.every(value => value?.amount === 0 || value?.amount === null)}
                                      />
                                    </div>
                                  </div>
                                )}
                              </React.Fragment>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Detail cost view */}
                  <div
                    className={`tab-pane fade ${viewState === "detail" ? "show active" : ""}`}
                    id="detail"
                    role="tabpanel"
                    aria-labelledby="detail-tab"
                    tabIndex={0}
                  >
                    <div className="page_main_content_section">
                      <DataTable
                        value={developmentAppraisalData}
                        size="small"
                        emptyMessage="No task found!"
                        tableStyle={{ minWidth: "50rem" }}
                        className="page_table dev_app_table p-0 p-sm-2"
                        rowHover
                        scrollable
                        loading={dataLoading}
                      >
                        <Column
                          headerClassName="d-none"
                          body={(rowData: DevelopmentAppraisalDataList, { rowIndex }) =>
                            rowData?.development_appraisal?.appraisal_name ? (
                              <span>
                                {rowIndex + 1}.&nbsp;&nbsp;&nbsp;
                                {rowData.development_appraisal.appraisal_name}
                              </span>
                            ) : (
                              "--"
                            )
                          }
                          style={{ width: "25%" }}
                        ></Column>

                        <Column
                          headerClassName="d-none"
                          body={addDataBody}
                          style={{ width: "25%" }}
                        ></Column>

                        <Column
                          headerClassName="d-none"
                          body={amountDataBody}
                          style={{ width: "25%" }}
                        ></Column>

                        <Column
                          headerClassName="d-none"
                          body={viewDataBody}
                          className="table_btn_area"
                          // style={{ width: "25%" }}
                          frozen
                          alignFrozen="right"
                        ></Column>
                      </DataTable>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <div className="page_main_content_section">
                <NoDataCreated message={`No data found.`} />
              </div>
            )}
          </div>
        )}
      </div>

      {/* ******************************** Basic cost ********************************* */}
      {/* Basic cost modal */}
      <Dialog
        visible={showBasicCostModal}
        header={basicCostModalHeader}
        footer={basicCostModalFooter}
        headerClassName="custom_modal_header"
        className="custom_modal_dialog modal_dialog_md"
        onHide={handleCloseBasicCostModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          {costValues && costValues?.length > 0 && (
            <div className="add_cost_section">
              {costValues?.map((cost, index) => {
                return (
                  <div key={`third_${cost?.id}`} className="row mb-2">
                    <div className="col-7 col-sm-8 pe-sm-2 pe-1">
                      <div className="cost_title_grp">
                        <span>{index + 1}.</span>
                        <label
                          htmlFor={`basicCost-${index}`}
                          className="cost_title"
                        >
                          {cost?.development_appraisal?.appraisal_name}
                        </label>
                      </div>
                    </div>
                    <div className="col-5 col-sm-4 ps-sm-2 ps-1">
                      <div className="cost_value_grp add">
                        <InputNumber
                          inputId={`basicCost-${index}`}
                          value={cost.amount}
                          onValueChange={(e) => {
                            const newValue = e.value || 0;
                            handleCostChange(newValue, cost?.id!);
                          }}
                          minFractionDigits={2}
                          maxFractionDigits={2}
                          mode="currency"
                          currency="GBP"
                          locale="en-UK"
                          className="cost_input w-100"
                          placeholder={currencySymbol + "0.00"}
                        />
                        {(delete_data && !isShared) && (
                          <React.Fragment>
                            {basicCostDeleteLoadingId === cost?.id ? (
                              <TableActionLoader className="modal_multi_delete_loder" />
                            ) : (
                              <button
                                type="button"
                                className="close_modal_btn cost_delete p-ripple"
                                onClick={() => handleRemoveBasicCost(cost)}
                              >
                                <i className="bi bi-trash3"></i>
                                <Ripple />
                              </button>
                            )}
                          </React.Fragment>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </Dialog>
      {/* ***************************************************************************** */}

      {/* ******************************** Finance cost ******************************** */}
      {/* Finance cost modal */}
      <Dialog
        header={financeCostModalHeader}
        footer={financeCostModalFooter}
        visible={showFinanceCostModal}
        headerClassName="custom_modal_header"
        className="custom_modal_dialog modal_dialog_md"
        onHide={handleCloseFinanceCostModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          <div className="add_cost_section">
            {/* Finance amount */}
            <div className="row mb-2">
              <div className="col-7 col-sm-8 pe-sm-2 pe-1">
                <div className="cost_title_grp">
                  <span>1.</span>
                  <label htmlFor="financeAmount" className="cost_title">
                    Finance amount
                  </label>
                </div>
              </div>
              <div className="col-5 col-sm-4 ps-sm-2 ps-1">
                <InputNumber
                  inputId="financeAmount"
                  value={financeAmount}
                  onValueChange={(e: InputNumberValueChangeEvent) =>
                    setFinanceAmount(e.value !== null && e.value !== undefined ? e.value : null)
                  }
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="currency"
                  currency="GBP"
                  locale="en-UK"
                  className="cost_input w-100"
                  placeholder={currencySymbol + "0.00"}
                />
              </div>
            </div>

            {/* Interest rate */}
            <div className="row mb-2">
              <div className="col-7 col-sm-8 pe-sm-2 pe-1">
                <div className="cost_title_grp">
                  <span>2.</span>
                  <label htmlFor="interestRate" className="cost_title">
                    Interest rate
                  </label>
                </div>
              </div>
              <div className="col-5 col-sm-4 ps-sm-2 ps-1">
                <InputNumber
                  inputId="interestRate"
                  value={interestRate}
                  onValueChange={(e: InputNumberValueChangeEvent) =>
                    setInterestRate(e.value !== null && e.value !== undefined ? e.value : null)
                  }
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  suffix=" %"
                  className="cost_input w-100"
                  placeholder="0.00 %"
                />
              </div>
            </div>

            {/* Loan month */}
            <div className="row mb-2">
              <div className="col-7 col-sm-8 pe-sm-2 pe-1">
                <div className="cost_title_grp">
                  <span>3.</span>
                  <label htmlFor="loanMonth" className="cost_title">
                    Loan month
                  </label>
                </div>
              </div>
              <div className="col-5 col-sm-4 ps-sm-2 ps-1">
                <InputNumber
                  inputId="loanMonth"
                  value={loanMonth}
                  onValueChange={(e: InputNumberValueChangeEvent) =>
                    setLoanMonth(e.value !== null && e.value !== undefined ? e.value : null)
                  }
                  className="cost_input w-100"
                  suffix=" Month(s)"
                  placeholder="0"
                />
              </div>
            </div>

            {/* Interest amount */}
            <div className="row mb-2">
              <div className="col-7 col-sm-8 pe-sm-2 pe-1">
                <div className="cost_title_grp">
                  <span>4.</span>
                  <label htmlFor="interestAmount" className="cost_title">
                    Interest amount
                  </label>
                </div>
              </div>
              <div className="col-5 col-sm-4 ps-sm-2 ps-1">
                <InputNumber
                  inputId="interestAmount"
                  value={interestAmount}
                  onValueChange={(e: InputNumberValueChangeEvent) =>
                    setInterestAmount(e.value !== null && e.value !== undefined ? e.value : null)
                  }
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="currency"
                  currency="GBP"
                  locale="en-UK"
                  className="cost_input w-100"
                  placeholder="0"
                />
              </div>
            </div>

            {/* Arrangement fee */}
            <div className="row mb-2">
              <div className="col-7 col-sm-8 pe-sm-2 pe-1">
                <div className="cost_title_grp">
                  <span>5.</span>
                  <label htmlFor="arrangementFee" className="cost_title">
                    Arrangement fee
                  </label>
                </div>
              </div>
              <div className="col-5 col-sm-4 ps-sm-2 ps-1">
                <InputNumber
                  inputId="arrangementFee"
                  value={arrangementFee}
                  onValueChange={(e: InputNumberValueChangeEvent) =>
                    setArrangementFee(e.value !== null && e.value !== undefined ? e.value : null)
                  }
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  max={100}
                  mode="currency"
                  currency="GBP"
                  locale="en-UK"
                  className="cost_input w-100"
                  placeholder="0"
                />
              </div>
            </div>

            {/* Exist fee */}
            <div className="row mb-2">
              <div className="col-7 col-sm-8 pe-sm-2 pe-1">
                <div className="cost_title_grp">
                  <span>6.</span>
                  <label htmlFor="existFee" className="cost_title">
                    Exist fee
                  </label>
                </div>
              </div>
              <div className="col-5 col-sm-4 ps-sm-2 ps-1">
                <InputNumber
                  inputId="existFee"
                  value={existFee}
                  onValueChange={(e: InputNumberValueChangeEvent) =>
                    setExistFee(e.value !== null && e.value !== undefined ? e.value : null)
                  }
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  max={100}
                  mode="currency"
                  currency="GBP"
                  locale="en-UK"
                  className="cost_input w-100"
                  placeholder="0"
                />
              </div>
            </div>

            {/* Lawyer fee */}
            <div className="row mb-2">
              <div className="col-7 col-sm-8 pe-sm-2 pe-1">
                <div className="cost_title_grp">
                  <span>7.</span>
                  <label htmlFor="lawyerFee" className="cost_title">
                    Lawyer fee
                  </label>
                </div>
              </div>
              <div className="col-5 col-sm-4 ps-sm-2 ps-1">
                <InputNumber
                  inputId="lawyerFee"
                  value={lawyerFee}
                  onValueChange={(e: InputNumberValueChangeEvent) =>
                    setLawyerFee(e.value !== null && e.value !== undefined ? e.value : null)
                  }
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="currency"
                  currency="GBP"
                  locale="en-UK"
                  className="cost_input w-100"
                  placeholder="0"
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      {/* Finance cost view modal */}
      <Dialog
        visible={showFinanceCostViewModal}
        headerClassName="d-none"
        contentClassName="p-0"
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseFinanceCostViewModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          {financeCostData && financeCostData !== null && (
            <article className="cost_view_container">
              <div className="cost_view_header">
                <button
                  className="data_action_btn cost_edit_btn float  p-ripple"
                  onClick={handleCloseFinanceCostViewModal}
                >
                  <i className="bi bi-x-circle"></i>
                  <Ripple />
                </button>

                {(edit_detail_cost && !isShared) && (
                  <button
                    className="data_action_btn cost_edit_btn float left  p-ripple"
                    onClick={() => handleEditFinanceCost(financeCostData)}
                  >
                    <i className="bi bi-pencil-square"></i>
                    <Ripple />
                  </button>
                )}

                <div className="cost_total_area">
                  <h5>Finance cost total</h5>
                  <h5>
                    {currencySymbol}&nbsp;{formatAmount(financeTotalCost)}
                  </h5>
                </div>
              </div>
              <div className="cost_view_body">
                <div className="cost_view_data_area">
                  <h6 className="cost_view_title">Finance amount</h6>
                  <h6 className="cost_view_value">
                    {currencySymbol}&nbsp;
                    {formatAmount(financeCostData?.finance_amount)}
                  </h6>
                </div>
                <div className="cost_view_data_area">
                  <h6 className="cost_view_title">Interest rate</h6>
                  <h6 className="cost_view_value">
                    {financeCostData?.interest_rate}%
                  </h6>
                </div>
                <div className="cost_view_data_area">
                  <h6 className="cost_view_title">Loan month</h6>
                  <h6 className="cost_view_value">
                    {financeCostData?.loan_month} months
                  </h6>
                </div>
                <div className="cost_view_data_area">
                  <h6 className="cost_view_title">Interest amount</h6>
                  <h6 className="cost_view_value">
                    {currencySymbol}&nbsp;
                    {formatAmount(financeCostData?.interest)}
                  </h6>
                </div>
                <div className="cost_view_data_area">
                  <h6 className="cost_view_title">Arrangement fee</h6>
                  <h6 className="cost_view_value">
                    {currencySymbol}&nbsp;
                    {formatAmount(financeCostData?.arrangement_fees)}
                  </h6>
                </div>
                <div className="cost_view_data_area">
                  <h6 className="cost_view_title">Exist fee</h6>
                  <h6 className="cost_view_value">
                    {currencySymbol}&nbsp;
                    {formatAmount(financeCostData?.exist_fees)}
                  </h6>
                </div>
                <div className="cost_view_data_area">
                  <h6 className="cost_view_title">Lawyer fee</h6>
                  <h6 className="cost_view_value">
                    {currencySymbol}&nbsp;
                    {formatAmount(financeCostData?.lawyer_fees)}
                  </h6>
                </div>
              </div>
            </article>
          )}
        </div>
      </Dialog>
      {/* ***************************************************************************** */}

      {/* ******************************** Land cost ******************************** */}
      {/* Land cost modal */}
      <Dialog
        visible={showLandCostModal}
        header={landCostModalHeader}
        footer={landCostModalFooter}
        headerClassName="custom_modal_header"
        className="custom_modal_dialog modal_dialog_md"
        onHide={handleCloseLandCostModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          <div className="add_cost_section">
            {/* Purchase price */}
            <div className="row mb-2">
              <div className="col-7 col-sm-8 pe-sm-2 pe-1">
                <div className="cost_title_grp">
                  <span>1.</span>
                  <label htmlFor="landPurchasePrice" className="cost_title">
                    Purchase price
                  </label>
                </div>
              </div>
              <div className="col-5 col-sm-4 ps-sm-2 ps-1">
                <InputNumber
                  inputId="landPurchasePrice"
                  value={landPurchasePrice}
                  onValueChange={(e: InputNumberValueChangeEvent) =>
                    setLandPurchasePrice(e.value !== null && e.value !== undefined ? e.value : null)
                  }
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="currency"
                  currency="GBP"
                  locale="en-UK"
                  className="cost_input w-100"
                  placeholder={currencySymbol + "0.00"}
                />
              </div>
            </div>

            {/* Fee */}
            <div className="row mb-2">
              <div className="col-7 col-sm-8 pe-sm-2 pe-1">
                <div className="cost_title_grp">
                  <span>2.</span>
                  <label htmlFor="landFee" className="cost_title">
                    Fee
                  </label>
                </div>
              </div>
              <div className="col-5 col-sm-4 ps-sm-2 ps-1">
                <InputNumber
                  inputId="landFee"
                  value={landFee}
                  onValueChange={(e: InputNumberValueChangeEvent) =>
                    setLandFee(e.value !== null && e.value !== undefined ? e.value : null)
                  }
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="currency"
                  currency="GBP"
                  locale="en-UK"
                  className="cost_input w-100"
                  placeholder="0"
                />
              </div>
            </div>

            {/* Stamp duty fee */}
            <div className="row mb-2">
              <div className="col-7 col-sm-8 pe-sm-2 pe-1">
                <div className="cost_title_grp">
                  <span>3.</span>
                  <label htmlFor="stampDutyFee" className="cost_title">
                    Stamp duty fee
                  </label>
                </div>
              </div>
              <div className="col-5 col-sm-4 ps-sm-2 ps-1">
                <InputNumber
                  inputId="stampDutyFee"
                  value={stampDutyFee}
                  onValueChange={(e: InputNumberValueChangeEvent) =>
                    setStampDutyFee(e.value !== null && e.value !== undefined ? e.value : null)
                  }
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="currency"
                  currency="GBP"
                  locale="en-UK"
                  className="cost_input w-100"
                  placeholder="0"
                />
              </div>
            </div>

            {/* Lawyer fee */}
            <div className="row mb-2">
              <div className="col-7 col-sm-8 pe-sm-2 pe-1">
                <div className="cost_title_grp">
                  <span>4.</span>
                  <label htmlFor="landLawyerFee" className="cost_title">
                    Lawyer fee
                  </label>
                </div>
              </div>
              <div className="col-5 col-sm-4 ps-sm-2 ps-1">
                <InputNumber
                  inputId="landLawyerFee"
                  value={landLawyerFee}
                  onValueChange={(e: InputNumberValueChangeEvent) =>
                    setLandLawyerFee(e.value !== null && e.value !== undefined ? e.value : null)
                  }
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="currency"
                  currency="GBP"
                  locale="en-UK"
                  className="cost_input w-100"
                  placeholder="0"
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      {/* Land cost view modal */}
      <Dialog
        visible={showLandCostViewModal}
        headerClassName="d-none"
        contentClassName="p-0"
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseLandCostViewModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          {landCostData && landCostData !== null && (
            <article className="cost_view_container">
              <div className="cost_view_header">
                <button
                  className="data_action_btn cost_edit_btn float  p-ripple"
                  onClick={handleCloseLandCostViewModal}
                >
                  <i className="bi bi-x-circle"></i>
                  <Ripple />
                </button>

                {(edit_detail_cost && !isShared) && (
                  <button
                    className="data_action_btn cost_edit_btn float left p-ripple"
                    onClick={() => handleEditLandCost(landCostData)}
                  >
                    <i className="bi bi-pencil-square"></i>
                    <Ripple />
                  </button>
                )}

                <div className="cost_total_area">
                  <h5>Land cost total</h5>
                  <h5>
                    {currencySymbol}&nbsp;{formatAmount(landTotalCost)}
                  </h5>
                </div>
              </div>
              <div className="cost_view_body">
                <div className="cost_view_data_area">
                  <h6 className="cost_view_title">Purchase price</h6>
                  <h6 className="cost_view_value">
                    {currencySymbol}&nbsp;
                    {formatAmount(landCostData?.purchase_price)}
                  </h6>
                </div>
                <div className="cost_view_data_area">
                  <h6 className="cost_view_title">Fee</h6>
                  <h6 className="cost_view_value">
                    {currencySymbol}&nbsp;{formatAmount(landCostData?.fees)}
                  </h6>
                </div>
                <div className="cost_view_data_area">
                  <h6 className="cost_view_title">Stamp duty fee</h6>
                  <h6 className="cost_view_value">
                    {currencySymbol}&nbsp;
                    {formatAmount(landCostData?.stamp_duty)}
                  </h6>
                </div>
                <div className="cost_view_data_area">
                  <h6 className="cost_view_title">Lawyer fee</h6>
                  <h6 className="cost_view_value">
                    {currencySymbol}&nbsp;
                    {formatAmount(landCostData?.lawyer_fees)}
                  </h6>
                </div>
              </div>
            </article>
          )}
        </div>
      </Dialog>
      {/* ***************************************************************************** */}

      {/* ********************************* Other cost ********************************* */}
      {/* Other cost modal */}
      <Dialog
        visible={showOtherCostModal}
        header={otherCostModalHeader}
        footer={otherCostModalFooter}
        headerClassName="custom_modal_header"
        className="custom_modal_dialog modal_dialog_md"
        onHide={handleCloseOtherCostModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          <div className="add_cost_section">
            {otherCostData?.map((cost, index) => {
              return (
                <div className="row mb-2" key={cost.id}>
                  <div className="col-7 pe-sm-2 pe-1">
                    <div className="cost_title_grp">
                      <span>{index + 1}.</span>
                      <label htmlFor={`cost_${cost.id}`} className="cost_title">
                        {cost.name}
                      </label>
                    </div>
                  </div>

                  <div className="col-5 ps-sm-2 ps-1">
                    <div className="cost_value_grp add">
                      <InputNumber
                        inputId={`cost_${cost.id}`}
                        value={cost.amount}
                        onValueChange={(e) => {
                          const updatedCosts: any = otherCostData?.map(
                            (element) => {
                              if (element.id === cost.id) {
                                return {
                                  id: element.id,
                                  appraisal_basic_id: element.appraisal_basic_id,
                                  amount: e.value || 0,
                                  is_default: element.is_default,
                                  name: element.name,
                                };
                              } else {
                                return element;
                              }
                            }
                          );
                          setOtherCostData(updatedCosts);
                        }}
                        minFractionDigits={2}
                        maxFractionDigits={2}
                        mode="currency"
                        currency="GBP"
                        locale="en-UK"
                        className="cost_input w-100"
                        placeholder={currencySymbol + "0.00"}
                      />

                      {cost.is_default === 0 && delete_detail_cost && !isShared && (
                        <React.Fragment>
                          {deletingIndex === index ? (
                            <TableActionLoader className="modal_multi_delete_loder" />
                          ) : (
                            <button
                              type="button"
                              className="close_modal_btn cost_delete p-ripple"
                              onClick={() => handleDeleteCost(index, cost?.id)}
                            >
                              <i className="bi bi-trash3"></i>
                              <Ripple />
                            </button>
                          )}
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}

            {dataState === "Add" || showMoreAdd ? (
              <React.Fragment>
                <div className="row mb-2">
                  <div className="col-7 pe-sm-2 pe-1">
                    <div className="cost_title_grp">
                      <span>{otherCostData.length + 1}.</span>
                      <InputText
                        value={otherCostTitle}
                        id="otherCostTitle"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          setOtherCostTitle(e.target.value)
                        }
                        className="cost_title_input"
                        placeholder="Enter cost title"
                        autoFocus={true}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <div className="col-5 ps-sm-2 ps-1">
                    <div className="cost_value_grp add">
                      <InputNumber
                        inputId="landPurchasePrice"
                        value={otherCostAmount}
                        onValueChange={(e: InputNumberValueChangeEvent) =>
                          setOtherCostAmount(e.value || 0)
                        }
                        minFractionDigits={2}
                        maxFractionDigits={2}
                        mode="currency"
                        currency="GBP"
                        locale="en-UK"
                        className="cost_input w-100"
                        placeholder={currencySymbol + "0.00"}
                      />

                      {dataState === 'Edit' && otherCostData.length > 0 && (
                        <button
                          type="button"
                          className="close_modal_btn cost_delete p-ripple"
                          onClick={handleRemoveCost}
                        >
                          <i className="bi bi-dash-circle"></i>
                          <Ripple />
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    {otherCostError && (
                      <small className="text-center form_error_msg with_bg">
                        {otherCostError}
                      </small>
                    )}
                  </div>
                </div>

                <div className="row pt-2">
                  <div className="col-12">
                    <button
                      className="add_data_btn p-ripple"
                      onClick={handleAddMoreCost}
                    >
                      <i className="bi bi-plus-circle"></i>
                      <span>Add more</span>
                      <Ripple />
                    </button>
                  </div>
                </div>
              </React.Fragment>
            ) : dataState === "Edit" && showMoreAdd === false ? (
              <div className="row pt-2">
                <div className="col-12">
                  <button
                    className="add_data_btn p-ripple"
                    onClick={handleToggleShowMore}
                  >
                    <i className="bi bi-plus-circle"></i>
                    <span>Add more</span>
                    <Ripple />
                  </button>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </Dialog>

      {/* Other cost view modal */}
      <Dialog
        visible={showOtherCostViewModal}
        headerClassName="d-none"
        contentClassName="p-0"
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseOtherCostViewModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          <article className="cost_view_container">
            <div className="cost_view_header">
              <button
                className="data_action_btn cost_edit_btn float p-ripple"
                onClick={handleCloseOtherCostViewModal}
              >
                <i className="bi bi-x-circle"></i>
                <Ripple />
              </button>

              {(edit_detail_cost && !isShared) && (
                <button
                  className="data_action_btn cost_edit_btn left float  p-ripple"
                  onClick={() => handleEditOtherCost(otherCostData)}
                >
                  <i className="bi bi-pencil-square"></i>
                  <Ripple />
                </button>
              )}

              <div className="cost_total_area">
                <h5>{appraisalName} total</h5>
                <h5>
                  {currencySymbol}&nbsp;{formatAmount(otherTotalCost)}
                </h5>
              </div>
            </div>
            {otherCostData && otherCostData?.length > 0 ? (
              <div className="cost_view_body">
                {otherCostData?.map((cost) => {
                  return (
                    <div key={cost?.id} className="cost_view_data_area">
                      <h6 className="cost_view_title">{cost?.name}</h6>
                      <h6 className="cost_view_value">
                        {currencySymbol}&nbsp;{formatAmount(cost?.amount)}
                      </h6>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="p-2 pb-0">
                <div className="feature_not_available_area h-100 p-5">
                  <h6>No data found.</h6>
                </div>
              </div>
            )}
          </article>
        </div>
      </Dialog>
      {/* ****************************************************************************** */}
    </React.Fragment>
  );
};

export default DevelopmentAppraisal;
